import { mainCalculations } from './mainCalculations';
import { formatAndConvertToNumber } from './formatAndConvertToNumber';
import { roundToThree } from './roundToThree';
const exceptions = ['id', 'project_id', 'guid', 'name', 'in_edit_mode', 'comment'];
const mainKey = ['length', 'width', 'height'];
export const recalculations = (openingsList, calculations) => {
    const openings = Object.values(openingsList);

    let openingSumValue = {
        door_quantity: 0,
        door_area: 0,
        door_perimeter: 0,
        door_slope_area: 0,
        door_slope_perimeter: 0,
        window_quantity: 0,
        window_area: 0,
        window_perimeter: 0,
        window_slope_area: 0,
        window_slope_perimeter: 0,
    };

    const openingSum = openings.reduce((accumulator, currentValue) => {
        if (currentValue.type === 'door') {
            accumulator.door_quantity += 1;
            accumulator.door_area += formatAndConvertToNumber(currentValue.area);
            accumulator.door_perimeter += formatAndConvertToNumber(currentValue.perimeter);
            accumulator.door_slope_area += formatAndConvertToNumber(currentValue.slope_area);
            accumulator.door_slope_perimeter += formatAndConvertToNumber(
                currentValue.slope_perimeter
            );
        } else {
            accumulator.window_quantity += 1;
            accumulator.window_area += formatAndConvertToNumber(currentValue.area);
            accumulator.window_perimeter += formatAndConvertToNumber(currentValue.perimeter);
            accumulator.window_slope_area += formatAndConvertToNumber(currentValue.slope_area);
            accumulator.window_slope_perimeter += formatAndConvertToNumber(
                currentValue.slope_perimeter
            );
        }

        return accumulator;
    }, openingSumValue);

    const formattedCalculations = { ...calculations };

    for (let key in formattedCalculations) {
        if (formattedCalculations.hasOwnProperty(key) && !exceptions.includes(key)) {
            formattedCalculations[key] =
                mainKey.includes(key) && formattedCalculations[key] === ''
                    ? ''
                    : roundToThree(formattedCalculations[key]);
        }
    }
    for (let key in openingSum) {
        if (openingSum.hasOwnProperty(key)) {
            openingSum[key] = roundToThree(openingSum[key]);
        }
    }

    return mainCalculations({ ...formattedCalculations, ...openingSum });
};
